import { GoogleStreetViewIcon } from './GoogleStreetViewIcon';

/**
 * author: Google
 * id EC38CB3D-A8A1-48E8-9A71-9BE93D6847FC
 * name google-street-view
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/google-street-view.svg
 * tags
 */
export const PegmanIcon = GoogleStreetViewIcon;
export default PegmanIcon